import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { AgreementPlan } from "@modules/agreementPlans/types";
import { AgreementPlanFormValues } from "@modules/agreementPlans/validations";

import { editAgreementPlanService } from "./service";
import { UseEditAgreementPlanMutationOptions } from "./types";

export function useEditAgreementPlanMutation(
  id: string,
  options?: UseEditAgreementPlanMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<AgreementPlan, ApiError, AgreementPlanFormValues>({
    mutationKey: ["agreementplan", id],
    mutationFn: (data: AgreementPlanFormValues) => editAgreementPlanService(id as string, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("agreement_agreementplans.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
